import { render, staticRenderFns } from "./EmailEdit.vue?vue&type=template&id=561f2f92"
import script from "./EmailEdit.vue?vue&type=script&lang=js"
export * from "./EmailEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports